import styles from "./Equipe.module.css";
import imagem from "../../Imgs/Equipe.png";
import { Link } from "react-router-dom";
function Equipe() {
  return (
    <div className={styles.container}>
      <h3 id="equipe">//Equipe</h3>
      <div className={styles.conteudo}>
        <p>
          Esse grupo é constituído por alunos do curso de Licenciatura em
          Geografia e do Programa de Pós-Graduação em Geografia da Universidade
          Federal de Pelotas (UFPel) e coordenado pela Profa. Dra. Gabriela
          Dambrós do departamento de Geografia da UFPel.
        </p>
        <img src={imagem} alt="Equipe"></img>
      </div>
      <div className={styles.bt}>
        <Link to="/equipep">conheça nossa equipe</Link>
      </div>
      <p></p>
    </div>
  );
}
export default Equipe;
